import React, { Component } from 'react';
import logo from '../assets/bitreel-logo-sans-text.png';
import './LogoLoader.scss';

class LogoLoader extends Component {
    render() {
        return (
            <div
                className={`bitreel-logo-spinner ${
                    this.props.small ? 'small' : ''
                } ${this.props.medium ? 'medium' : ''}`}
            >
                <div className="container">
                    {this.props.showLogo && <img src={logo} />}
                    {this.props.showSpinner && <div className="spinner"></div>}
                </div>
                {this.props.showBrandLogo && (
                    <img
                        className={`brand-logo ${
                            this.props.mobile ? 'mobile' : 'desktop'
                        }`}
                        src={this.props.showBrandLogo}
                    />
                )}
            </div>
        );
    }
}

export default LogoLoader;
